export default __webpack_public_path__ + "static/sepa-bc030b477c1a70ee886628740106d50b.svg";